export default {
  head: {
    icon: '/DAM-favicon.ico',
    text: 'DAM Corp'
  },
  login: {
    logoUrl: '/dam/dam-logo.svg',
  }
}